module.exports = __webpack_public_path__ + "static/media/img_dance08.73b841d2.png";